import { render, staticRenderFns } from "./voiceAi.vue?vue&type=template&id=b31f075a&scoped=true&"
import script from "./voiceAi.vue?vue&type=script&lang=js&"
export * from "./voiceAi.vue?vue&type=script&lang=js&"
import style0 from "./voiceAi.vue?vue&type=style&index=0&id=b31f075a&prod&scoped=true&lang=scss&"
import style1 from "./voiceAi.vue?vue&type=style&index=1&id=b31f075a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31f075a",
  null
  
)

export default component.exports